import auth0 from "auth0-js";
import decode from "jwt-decode";
import Sentry from "../Globals/sentry";
import { isTokenExpired } from "./jwtHelper";

class AuthService {
  constructor() {
    // // Configure Auth0
    // this.auth0 = new auth0.WebAuth({
    //   clientID: "6MPsXtcHw0DgFyZyO1M7A36tKz1qqE8V",
    //   clientSecret:
    //     "p0y_b62z8wo-oalDNSYlww9n6JqLA0UVzHJjVNgggy83wfXQ3lNZg4wj3cL6iUMk",
    //   domain: "jarlstrom.eu.auth0.com",
    //   responseType: "token id_token",
    //   redirectUri: `${window.location.origin}/login`,
    // });

    this.hostname = window.location.origin;
    this.login = this.login.bind(this);
  }

  async resetPassword(email) {
    const domain = process.env.REACT_APP_domain;
    const clientId = process.env.REACT_APP_clientId;
    var options = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        client_id: clientId,
        email,
        connection: "Username-Password-Authentication",
      }),
    };

    await fetch(`https://${domain}/dbconnections/change_password`, options);
  }

  async login(username, password, failed) {
    const domain = process.env.REACT_APP_domain;
    const clientId = process.env.REACT_APP_clientId;
    const response = await fetch(`https://${domain}/oauth/token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        grant_type: "password",
        username,
        password,
        audience: `https://${domain}/api/v2/`,
        scope: "openid profile email",
        client_id: clientId,
      }),
    })
      .then((reps) => {
        if (reps.status > 400) {
          throw new Error();
        }
        return reps.json();
      })
      .then((response) => {
        const { access_token: accessToken, id_token: idToken } = response;
        this.setToken(accessToken, idToken);
        let obj = decode(idToken);
        this.setProfile({
          ...obj,
          role: obj["https://ceas/role"],
          name: obj["https://ceas/fullname"],
        });
      })
      .catch(() => {
        failed();
      });
  }

  parseHash(hash) {}

  loggedIn() {
    // Checks if there is a saved token and it's still valid
    const token = this.getToken();
    if (!token) {
      return false;
    }
    return !isTokenExpired(token);
  }

  setToken(accessToken, idToken) {
    // Saves user access token and ID token into local storage
    localStorage.setItem("access_token", accessToken);
    localStorage.setItem("id_token", idToken);
  }

  setProfile(profile) {
    // Saves profile data to localStorage
    localStorage.setItem("profile", JSON.stringify(profile));
  }

  getProfile() {
    // Retrieves the profile data from localStorage
    const profile = localStorage.getItem("profile");
    if (!profile) return {};

    var parsed = JSON.parse(profile);
    parsed.username = parsed.email.substring(0, parsed.email.indexOf("@"));
    return parsed;
  }

  getEmailVerified() {
    // Retrieves the profile data from localStorage
    const profile = localStorage.getItem("profile");
    if (!profile) return {};

    var parsed = JSON.parse(profile);
    return parsed.email_verified;
  }

  getToken() {
    // Retrieves the user token from localStorage
    return localStorage.getItem("id_token");
  }

  logout() {
    // Clear user token and profile data from localStorage
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    localStorage.removeItem("profile");
  }
}

const auth = new AuthService();

export default auth;



// WEBPACK FOOTER //
// ./src/App/Login/authService.js